import { render, staticRenderFns } from "./newsletter-popup.vue?vue&type=template&id=2f27fdb7&"
import script from "./newsletter-popup.vue?vue&type=script&lang=js&"
export * from "./newsletter-popup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports